// @flow
import environment from '../../../../environment';
import { postCreator } from '../../../../http';

export const endpoints = Object.freeze({
  POST_CONFIRMATION: `${environment.apiUrl}/purchase/:orderId/progress/confirm-receive`,
});

export const postConfirmationApi = postCreator(fetch, endpoints.POST_CONFIRMATION);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/in-transit/api.js